import { axiosInstance } from '../../Authentication/AxiosInterceptor';
import { DevelopTemplate } from '../../Types/Develop/DevelopTemplate';
import { AreaDisplayInfo } from '../../Types/AreaDisplayInfo/AreaDisplayInfo';
import { PagedResponse } from '../../Types/Paging/PagedResponse';
import { AnalyseDataRequest } from '../../Types/Paging/PagedRequest';
import { dedupeAsync } from '../../Utils/dedupeAsync';

export const GetDevelopTemplate = async (templateId: string): Promise<DevelopTemplate> => {
  try {
    const response = await axiosInstance.get<DevelopTemplate>(`Develop/GetTemplate/${templateId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching develop template:', error);
    throw error;
  }
};

export async function GetPagedDevelopAreaDisplayInfosByClientAndUser(
  clientId: string,
  request: AnalyseDataRequest
): Promise<PagedResponse<AreaDisplayInfo>> {
  try {
    return await dedupeAsync(
      `develop-areas:${clientId}:${request.archived}:${request.pageNumber}:${request.searchTerm ?? ""}`,
      async () => {
        const response = await axiosInstance.put<PagedResponse<AreaDisplayInfo>>(
          `GetPagedDevelopAreaDisplayInfosByClientAndUser/${clientId}`,
          request
        );
        return response.data;
      }
    );
  } catch (error) {
    console.error('Error fetching develop areas:', error);
    throw error;
  }
}






